
import React, { Fragment } from 'react';
import PageTitle from '../../components/pagetitle/PageTitle';
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import CustomerUnit from '../../components/CustomerUnit/CustomerUnit';


const TUCKCustomerUnit = (props) => {

    return (
        <Fragment>
            <div className='index_ico page_wrapper'>
                <Header />
                <main className="page_content">
                    <PageTitle pageTitle={'TopCoin UK - Customer Unit & Cash Protection Policy'} pagesub={'Home'} />
                    <CustomerUnit />
                </main>
                <Footer />
                <Scrollbar />
            </div>
        </Fragment>
    )
};
export default TUCKCustomerUnit;